import check from "./check";
import debounce from "./debounce";
import deepCopy from "./deepCopy";
import each from "./each";
import empty from "./empty";
import format from "./format";
import getBrowserType from "./getBrowserType";
import getUID from "./getUID";
import getVerifyCode from "./getVerifyCode";
import has from "./has";
import includes from "./includes";
import indexOf from "./indexOf";
import isAndroid from "./isAndroid";
import isArray from "./isArray";
import isBool from "./isBool";
import isDate from "./isDate";
import isFn from "./isFn";
import isIOS from "./isIOS";
import isiPad from "./isiPad";
import isMap from "./isMap";
import isNaN from './isNaN';
import isNull from "./isNull";
import isNumber from "./isNumber";
import isObj from "./isObj";
import isPC from "./isPC";
import isPrimitive from "./isPrimitive";
import isPromise from "./isPromise";
import isRegExp from "./isRegExp";
import isSet from "./isSet";
import isString from "./isString";
import isSymbol from "./isSymbol";
import isUndefined from "./isUndefined";
import isWPhone from "./isWPhone";
import ltrim from "./ltrim";
import noop from "./noop";
import random from "./random";
import remove from "./remove";
import reverse from "./reverse";
import rtrim from "./rtrim";
import throttle from "./throttle";
import toFirstLower from "./toFirstLower";
import toFirstUpper from "./toFirstUpper";
import toKeys from "./toKeys";
import toLowerCase from "./toLowerCase";
import toParam from "./toParam";
import toQuery from "./toQuery";
import toUpperCase from "./toUpperCase";
import toValues from "./toValues";
import trim from "./trim";
import typeOf from "./typeOf";
import unique from "./unique";
import bind from './bind';
import extend from './extend';
export { check, debounce, deepCopy, each, empty, format, getBrowserType, getUID, getVerifyCode, has, includes, indexOf, isAndroid, isArray, isBool, isDate, isFn, isIOS, isiPad, isMap, isNaN, isNull, isNumber, isObj, isPC, isPrimitive, isPromise, isRegExp, isSet, isString, isSymbol, isUndefined, isWPhone, ltrim, noop, random, remove, reverse, rtrim, throttle, toFirstLower, toFirstUpper, toKeys, toLowerCase, toParam, toQuery, toUpperCase, toValues, trim, typeOf, unique, bind, extend };
